import { useEffect, useState } from "react";
import { api } from "../api.js";

const COLUMNS = [
  { id: "anfrage", label: "Anfrage" },
  { id: "kontaktiert", label: "Kontaktiert" },
  { id: "produktion", label: "In Produktion" },
  { id: "erledigt", label: "Erledigt" },
  { id: "abgesagt", label: "Abgesagt" },
];

function daysLeft(cancelledAt) {
  if (!cancelledAt) return null;
  const diff = 14 - Math.floor((Date.now() - new Date(cancelledAt).getTime()) / 86400000);
  return diff > 0 ? diff : 0;
}

export default function PipelineScreen() {
  const [requests, setRequests] = useState([]);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.requests().then(setRequests).catch(() => {});
    api.orders().then(setOrders).catch(() => {});
  }, []);

  const cards = {
    anfrage: requests.filter((r) => r.status === "neu").map((r) => ({ id: `r${r.id}`, title: r.customer_name, sub: r.product })),
    kontaktiert: requests.filter((r) => r.status === "kontaktiert").map((r) => ({ id: `r${r.id}`, title: r.customer_name, sub: r.product })),
    produktion: orders.filter((o) => o.stage === "produktion").map((o) => ({ id: `o${o.id}`, title: o.customer_name, sub: o.product })),
    erledigt: orders.filter((o) => o.stage === "erledigt").map((o) => ({ id: `o${o.id}`, title: o.customer_name, sub: o.product })),
    abgesagt: [
      ...requests.filter((r) => r.status === "abgesagt").map((r) => ({ id: `r${r.id}`, title: r.customer_name, sub: r.product, cancelledAt: r.cancelled_at })),
      ...orders.filter((o) => o.stage === "abgesagt").map((o) => ({ id: `o${o.id}`, title: o.customer_name, sub: o.product, cancelledAt: o.cancelled_at })),
    ],
  };

  return (
    <div className="dx-pipeline">
      {COLUMNS.map((col) => (
        <div key={col.id} className="dx-pipeline-col">
          <div className="dx-pipeline-col-header">{col.label} <span className="dx-muted">({cards[col.id].length})</span></div>
          <div className="dx-pipeline-cards">
            {cards[col.id].map((c) => (
              <div key={c.id} className="dx-pipeline-card">
                <strong>{c.title}</strong>
                <div className="dx-muted" style={{ fontSize: "12.5px" }}>{c.sub}</div>
                {c.cancelledAt ? (
                  <div className="dx-muted" style={{ fontSize: "11.5px", marginTop: "4px" }}>
                    noch {daysLeft(c.cancelledAt)} T.
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
